import { marked } from 'marked';

// Configure marked options for chat-friendly markdown
marked.use({
  gfm: true, // GitHub Flavored Markdown
  breaks: true, // Convert line breaks to <br>
  renderer: {
    // Override paragraph to not wrap in <p> tags (causes extra spacing in chat bubbles)
    paragraph({ tokens }) {
      const text = this.parser.parseInline(tokens);
      return `${text}<br>`;
    },
    // Override heading to use bold instead (no need for big headings in chat)
    heading({ tokens }) {
      const text = this.parser.parseInline(tokens);
      return `<strong>${text}</strong><br>`;
    },
  },
});

/**
 * Parses markdown content to HTML
 * Designed for chat messages with simple formatting
 */
export const parseMarkdown = (content: string): string => {
  if (!content) return '';

  // Parse markdown to HTML
  let html = marked.parse(content, { async: false }) as string;

  // Clean up <br> before block elements (prevents double spacing)
  html = html.replace(/<br>\s*(<ul|<ol|<pre|<blockquote)/gi, '$1');

  // Clean up <br> after block elements
  html = html.replace(/(<\/ul>|<\/ol>|<\/pre>|<\/blockquote>)\s*<br>/gi, '$1');

  // Clean up <br> inside list items (before </li>)
  html = html.replace(/<br>\s*<\/li>/gi, '</li>');

  // Clean up <br> after opening list item
  html = html.replace(/<li>\s*<br>/gi, '<li>');

  // Clean up trailing <br> tags
  html = html.replace(/(<br>\s*)+$/, '');

  // Clean up multiple consecutive <br> tags (max 2)
  html = html.replace(/(<br>\s*){3,}/gi, '<br><br>');

  return html;
};
